<div id="acom">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="inner-card">
                    <h4 class="card-title">School Houses</h4>
                    <div class="card-body text-justify">
                        <p class="inner-lead">Students are divided into four houses, named after the holy rivers Ganga, Yamuna , Kaveri & Narmada . Just as water in the rivers finds its way through any kind of physical impediment similarly we, at school , teach the children that life is an ongoing  process so they should confront the challenges in life  boldly by overcoming  the obstacles & learn to adjust to different situations. </p>
                      <div class="row">
                          <div class="col-12 col-md-6">
                              <div class="card card1">
                                  <div class="card-body text-center">
                                      <h3>Ganga- Blue </h3>
                                      <p class="inner-lead">Blue is a serene and calming color that represents intelligence and responsibility</p>
                                  </div>
                              </div>
                          </div>
                          <div class="col-12 col-md-6">
                              <div class="card card2">
                                <div class="card-body text-center text-dark">
                                    <h3>Yamuna- Yellow </h3>
                                    <p class="inner-lead text-dark">Yellow, the color of sunshine, hope, and happiness</p>
                                </div>
                              </div>
                          </div>
                          <div class="col-12 col-md-6">
                              <div class="card card3">
                                <div class="card-body text-center">
                                    <h3>Narmada – Green </h3>
                                    <p class="inner-lead">Green is a cool color that symbolizes nature and represent good luck and health</p>
                                </div>
                              </div>
                          </div>
                          <div class="col-12 col-md-6">
                              <div class="card card4">
                                <div class="card-body text-center">
                                    <h3>Kaveri- Red </h3>
                                    <p class="inner-lead">Red is associated with the heat of energy, passion and love</p>
                                </div>
                              </div>
                          </div>
                      </div>
                       
                      <div class="row text-center">
                        <div class="col-12">
                         <a  href="/assets/img/admission/houses/1.jpeg" data-lightbox="Houses"> <img src="/assets/img/admission/houses/1.jpeg" alt="Ground" class="img-fluid rounded"></a>
                         </div>
                    </div>
                    </div>
                </div>

            </div>
        </div>

       
    </div>
</div>